import {useMemo} from 'react';

import {getActionSuggestionForLead} from './finder';
import type { ILead } from 'src/services/api/leads/types';
import type { IMessage } from 'src/services/api/messages/types';
import {type IActionSuggestion} from './types';
import {type IShowing} from 'src/api/landlord-showings-api';

interface Props {
    lead?: ILead;
    messages?: IMessage[];
    showings?: IShowing[];
}

export const useActionSuggestions = (props: Props): IActionSuggestion | undefined => {
    const {lead, messages, showings} = props;
    return useMemo(() => {
        if (!lead || !messages || !showings) {
            return;
        }

        return getActionSuggestionForLead(lead, messages, showings);
    }, [lead, messages, showings]);
};
